import DetailsDisclosure from './DetailsDisclosure';
import HeaderMenu from './HeaderMenu';
import DetailsModal from './DetailsModal';
import SearchForm from './SearchForm';
import PredictiveSearch from './PredictiveSearch';

import QuantityInput from './QuantityInput';
import MenuDrawer from './MenuDrawer';
import HeaderDrawer from './HeaderDrawer';

import AnnouncementBar from './AnnouncementBar';

import ProductInfo from './ProductInfo';
import ProductForm from './ProductForm';

import XScroller from './XScroller';

import ModalDialog from './ModalDialog';
import BulkModal from './BulkModal';
import ModalOpener from './ModalOpener';
import DeferredMedia from './DefferedMedia';
import SliderComponent from './SliderComponent';
import SlideshowComponent from './SlideshowComponent';
import VariantSelects from './VariantSelects';
import ProductRecommendations from './ProductRecommendations';
import AccountIcon from './AccountIcon';
import BulkAdd from './BulkAdd';
import XSwiper from './XSwiper';
import CustomerCity from './CustomerCity';
import QuickAddModal from './QuickAddModal';

import CartRemoveButton from './CartRemoveButton';
import CartItems from './CartItems';
import CartNote from './CartNote';

import CartNotification from './CartNotification';

import CartDrawer from './CartDrawer';
import CartDrawerItems from './CartDrawerItems';

import LocalizationForm from './LocalizationForm';

import FacetFiltersForm from './FacetFiltersForm';

import PriceRange from './PriceRange';
import FacetRemove from './FacetRemove';

import MediaGallery from './MediaGallery';

import MainSearch from './MainSearch';

import PasswordModal from './PasswordModel';

import PickupAvailability from './PickupAvailability';
import PickupAvailabilityDrawer from './PickupAvailabilityDrawer';

import ShowMoreButton from './ShowMore';

import PricePerItem from './PricePerItem';

import ProductModal from './ProductModal';

import ProductModel from './ProductModel';

import ShareButton from './ShareButton';

import QuantityPopover from './QuantityPopover';
import QuickAddBulk from './QuickAddBulk';
import RecipientForm from './RecipientForm';

export default function registerComponents() {
  customElements.define('details-disclosure', DetailsDisclosure);
  customElements.define('header-menu', HeaderMenu);
  customElements.define('announcement-bar', AnnouncementBar);
  customElements.define('details-modal', DetailsModal);
  customElements.define('search-form', SearchForm);
  customElements.define('predictive-search', PredictiveSearch);

  customElements.define('quantity-input', QuantityInput);
  customElements.define('menu-drawer', MenuDrawer);
  customElements.define('header-drawer', HeaderDrawer);

  customElements.define('product-info', ProductInfo);
  customElements.define('product-form', ProductForm);

  customElements.define('x-scroller', XScroller);

  customElements.define('modal-dialog', ModalDialog);
  customElements.define('bulk-modal', BulkModal);
  customElements.define('modal-opener', ModalOpener);
  customElements.define('deferred-media', DeferredMedia);
  customElements.define('slider-component', SliderComponent);
  customElements.define('slideshow-component', SlideshowComponent);
  customElements.define('variant-selects', VariantSelects);
  customElements.define('product-recommendations', ProductRecommendations);
  customElements.define('account-icon', AccountIcon);
  customElements.define('bulk-add', BulkAdd);
  customElements.define('x-swiper', XSwiper);
  customElements.define('x-customer-city', CustomerCity);
  customElements.define('quick-add-modal', QuickAddModal);

  customElements.define('cart-remove-button', CartRemoveButton);
  customElements.define('cart-items', CartItems);
  customElements.define('cart-note', CartNote);

  customElements.define('cart-notification', CartNotification);

  customElements.define('cart-drawer', CartDrawer);
  customElements.define('cart-drawer-items', CartDrawerItems);

  customElements.define('localization-form', LocalizationForm);

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();

  customElements.define('price-range', PriceRange);
  customElements.define('facet-remove', FacetRemove);

  customElements.define('media-gallery', MediaGallery);

  customElements.define('main-search', MainSearch);

  customElements.define('password-modal', PasswordModal);

  customElements.define('pickup-availability', PickupAvailability);
  customElements.define('pickup-availability-drawer', PickupAvailabilityDrawer);

  customElements.define('show-more-button', ShowMoreButton);

  customElements.define('price-per-item', PricePerItem);

  customElements.define('product-modal', ProductModal);

  customElements.define('product-model', ProductModel);
  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },

    setupShopifyXR(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
        return;
      }

      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  });

  customElements.define('share-button', ShareButton);

  customElements.define('quantity-popover', QuantityPopover);
  customElements.define('quick-add-bulk', QuickAddBulk);
  customElements.define('recipient-form', RecipientForm);
}
